import {
	FlightAncillaryTypeEnum,
	BaggageEnum,
	GDSEnum,
	IFlightAncillaryTypeOption,
	IGDSOption,
	ISelectOption,
	EmissionsRequestTypeEnum,
	RefundRequestTypeEnum,
	OperationsRequestTypeEnum,
	CreditCardInquiryTypeEnum,
	ProviderPayableLinePaymentStatusEnum,
	ProviderPayableLineTypeEnum,
} from './types';
import routes from '../../constants/routes';

export const noAplicaGenerico: ISelectOption = {
	id: 'n/a',
	name: 'No Aplica',
};

export const gdsOptions: IGDSOption[] = [
	{ ...(noAplicaGenerico as IGDSOption) },
	{
		id: GDSEnum.Amadeus,
		name: 'Amadeus',
	},
	{
		id: GDSEnum.Sabre,
		name: 'Sabre',
	},
	{
		id: GDSEnum.Starlings,
		name: 'Starlings',
	},
	{
		id: GDSEnum.PlatformOfProvider,
		name: 'Plataforma del proveedor',
	},
	// {
	// 	id: GDSEnum.NDS,
	// 	name: 'NDS',
	// },
	// {
	// 	id: GDSEnum.NDX,
	// 	name: 'NDX',
	// },
	{
		id: GDSEnum.NDC,
		name: 'NDC',
	},
];

export const baggageOptions: ISelectOption[] = [
	{
		id: BaggageEnum.None,
		name: 'Sin equipaje',
	},
	{
		id: BaggageEnum.OneWay1x23KG,
		name: 'Solo ida -  1 x 23kg',
	},
	{
		id: BaggageEnum.OneWay2x23KG,
		name: 'Solo ida -  2 x 23kg',
	},
	{
		id: BaggageEnum.OneWay1x32KG,
		name: 'Solo ida -  1 x 32kg',
	},
	{
		id: BaggageEnum.OneWay2x32KG,
		name: 'Solo ida -  2 x 32kg',
	},

	{
		id: BaggageEnum.OnlyReturn1x23KG,
		name: 'Solo vuelta -  1 x 23kg',
	},
	{
		id: BaggageEnum.OnlyReturn2x23KG,
		name: 'Solo vuelta -  2 x 23kg',
	},
	{
		id: BaggageEnum.OnlyReturn1x32KG,
		name: 'Solo vuelta -  1 x 32kg',
	},
	{
		id: BaggageEnum.OnlyReturn2x32KG,
		name: 'Solo vuelta -  2 x 32kg',
	},
	{
		id: BaggageEnum.RoundTrip1x23KG,
		name: 'Ida y vuelta -  1 x 23kg',
	},
	{
		id: BaggageEnum.RoundTrip2x23KG,
		name: 'Ida y vuelta -  2 x 23kg',
	},
	{
		id: BaggageEnum.RoundTrip1x32KG,
		name: 'Ida y vuelta -  1 x 32kg',
	},
	{
		id: BaggageEnum.RoundTrip2x32KG,
		name: 'Ida y vuelta -  2 x 32kg',
	},
];

export const flightAncillaryOptions: IFlightAncillaryTypeOption[] = [
	{
		id: FlightAncillaryTypeEnum.Seat,
		name: 'Asientos',
	},
	{
		id: FlightAncillaryTypeEnum.CabinBaggage,
		name: 'Equipaje en cabina',
	},
	{
		id: FlightAncillaryTypeEnum.CheckedBaggage,
		name: 'Equipaje en bodega',
	},
	{
		id: FlightAncillaryTypeEnum.Pet,
		name: 'Mascota',
	},
	{
		id: FlightAncillaryTypeEnum.InFlightEntertainment,
		name: 'Entretenimiento a bordo',
	},
	{
		id: FlightAncillaryTypeEnum.Meal,
		name: 'Comidas',
	},
	{
		id: FlightAncillaryTypeEnum.SpecialLuggage,
		name: 'Equipajes especiales',
	},
	{
		id: FlightAncillaryTypeEnum.AccompaniedMinor,
		name: 'Menor acompañado',
	},
];

export const serviceTypeToEmoji: Record<string, { emoji: string; name: string }> = {
	Accommodation: { emoji: '🛏️', name: 'Alojamiento' },
	Flight: { emoji: '✈️', name: 'Vuelo' },
	FlightAncillary: { emoji: '🧳', name: 'Adicionales de vuelo' },
	Other: { emoji: '🧩', name: 'Otros' },
	Transfer: { emoji: '🚌', name: 'Traslados' },
	Fee: { emoji: '💵', name: 'Fee' },
};

export const handleOpenSaleOrderDetail = (id: string, serviceId: string, agencyId?: number) => (): void => {
	const params = new URLSearchParams({ serviceId });
	if (agencyId) params.set('agencyId', String(agencyId));
	const newUrl = `${routes.salesOrder.edit.replace(':id', id)}?${params.toString()}`;
	window.open(newUrl, '_blank');
};

export const EMISSIONS_REQUEST_TYPE_LABELS: Record<EmissionsRequestTypeEnum, string> = {
	[EmissionsRequestTypeEnum.VoidTicket]: 'Voidear boleto',
	[EmissionsRequestTypeEnum.OpenTicket]: 'Apertura de boleto',
	[EmissionsRequestTypeEnum.SpecialServices]: 'Servicios especiales',
	[EmissionsRequestTypeEnum.InvoluntaryChangeConfirmation]: 'Confirmación de cambios involuntarios',
	[EmissionsRequestTypeEnum.VoluntaryChangeQuotation]: 'Cotización de cambios voluntarios',
	[EmissionsRequestTypeEnum.NameCorrection]: 'Corrección de nombres',
	[EmissionsRequestTypeEnum.AddOnsQuotation]: 'Cotización de adicionales',
};

export const REFUND_TYPE_META: Record<RefundRequestTypeEnum, { label: string; description: string }> = {
	[RefundRequestTypeEnum.Voluntary]: {
		label: 'Voluntaria',
		description: 'Cuando el cliente quiere mandar a devolución uno o más servicios. Es una necesidad del cliente.',
	},
	[RefundRequestTypeEnum.Immediate]: {
		label: 'Inmediata',
		description:
			'Cuando nosotros o uno de nuestros proveedores cometió un error por lo que debemos reembolsar al cliente lo más pronto posible.',
	},
};

export const OPERATIONS_REQUEST_TYPE_LABELS: Record<OperationsRequestTypeEnum, string> = {
	[OperationsRequestTypeEnum.LateArrival]: 'Aviso de llegada tardía',
	[OperationsRequestTypeEnum.Modification]: 'Modificación de una reserva',
	[OperationsRequestTypeEnum.Cancellation]: 'Solicitud de cancelación de una reserva',
};

export const CREDIT_CARD_INQUIRY_TYPE_LABELS: Record<CreditCardInquiryTypeEnum, string> = {
	[CreditCardInquiryTypeEnum.Chargeback]: 'Contracargos y Desconocimientos de compra',

	[CreditCardInquiryTypeEnum.DuplicateCharge]: 'Cobros duplicados',

	[CreditCardInquiryTypeEnum.MissingCharge]: 'Avisos de no cobro por parte del cliente',

	[CreditCardInquiryTypeEnum.Reprocessing]: 'Reprocesamiento',
};

export const PROVIDER_PAYABLE_LINE_STATUS_LABEL: Record<ProviderPayableLinePaymentStatusEnum, string> = {
	[ProviderPayableLinePaymentStatusEnum.Pending]: 'Pendiente',
	[ProviderPayableLinePaymentStatusEnum.Partial]: 'Parcial',
	[ProviderPayableLinePaymentStatusEnum.Paid]: 'Pagado',
	[ProviderPayableLinePaymentStatusEnum.Cancelled]: 'Cancelado',
};

export const PROVIDER_PAYABLE_LINE_STATUS_COLOR: Record<
	ProviderPayableLinePaymentStatusEnum,
	'default' | 'warning' | 'success' | 'error'
> = {
	[ProviderPayableLinePaymentStatusEnum.Pending]: 'error',
	[ProviderPayableLinePaymentStatusEnum.Partial]: 'warning',
	[ProviderPayableLinePaymentStatusEnum.Paid]: 'success',
	[ProviderPayableLinePaymentStatusEnum.Cancelled]: 'default',
};

export const PROVIDER_PAYABLE_LINE_TYPE_LABEL: Record<ProviderPayableLineTypeEnum, string> = {
	[ProviderPayableLineTypeEnum.Service]: 'Servicio',
	[ProviderPayableLineTypeEnum.FlightTicket]: 'Ticket vuelo',
	[ProviderPayableLineTypeEnum.FlightAncillaryTicket]: 'Ticket ancillary',
};
